import React from 'react';

const Service = () => {
    return (
        <div>
            <h2 className='text-3xl' > Service</h2>
        </div>
    );
};

export default Service;